import {
  type FormikProps,
  FormikRadioGroup,
} from '@festina-life/ui/formikForms'
import { useTranslate } from '@festina-life/ui/hooks'

import type { BranchCreationInput } from '../types'
import { validate } from './helpers'

type Props = {
  state: FormikProps<BranchCreationInput>
}

export const TypesQuestionStep = ({ state: { values } }: Props) => {
  const translate = useTranslate()

  return (
    <FormikRadioGroup
      label={translate('branchCreationWizard.typesQuestionStep.description', {
        category: values.category,
      })}
      options={[true, false]}
      renderFn={(value) =>
        value
          ? translate('branchCreationWizard.typesQuestionStep.yes')
          : translate('branchCreationWizard.typesQuestionStep.no')
      }
      name={validate('shouldDefineTypes')}
    />
  )
}
